import React from 'react';
import DialogMessage from '../../Dialog';
import { renderToString } from 'react-dom/server'
import { prettyDate } from '../../../utils/date';

const capitalize = (s) => {
   if (typeof s !== 'string') return ''
   return s.charAt(0).toUpperCase() + s.slice(1)
}

const schedulingReport = (results) => (
  <>
    <strong style={{fontSize: '1.3em', textAlign: 'center', width: '100%', display: 'block'}}>
      {results?.message}
    </strong>
    <hr/>
    <strong style={{fontSize: '1.3em', textAlign: 'center', width: '100%', display: 'block'}}>
      {`Agendamentos`}
    </strong>
    <hr />
      <table style={{width: '100%'}}>
        <thead>
          <tr>
            <th style={{ textAlign: 'left' }}>ID</th>
            <th style={{ textAlign: 'left' }}>Cliente</th>
            <th style={{ textAlign: 'left' }}>Data</th>
            <th style={{ textAlign: 'left' }}>Tipo</th>
            <th style={{ textAlign: 'left' }}>Produto</th>
            <th style={{ textAlign: 'left' }}>Status</th>
          </tr>
        </thead>
        <tbody>
          {results?.data?.schedulings?.affectedSchedulings.map((d, index) => (
          <tr key={index}>
            <td style={{ textAlign: 'left' }}>{d.id_scheduling}</td>
            <td style={{ textAlign: 'left' }}>{capitalize(d.client_name)}</td>
            <td style={{textAlign: 'left'}}>{prettyDate(d.scheduling_date)}</td>
            <td style={{ textAlign: 'left' }}>{d.description}</td>
            <td style={{textAlign: 'left'}}>{d.product_name}</td>
            <td style={{ textAlign: 'left' }}>{capitalize(d.scheduling_status)}</td>
          </tr>
          ))}
        </tbody>
      </table>
    <hr />
  </>
);

const quotaReport = (results) => (
  <>
    <strong style={{fontSize: '1.3em', textAlign: 'center', width: '100%', display: 'block'}}>
      {results?.message}
    </strong>
    <hr/>
    <strong style={{fontSize: '1.3em', textAlign: 'center', width: '100%', display: 'block'}}>
      {`Cota por Planta`}
    </strong>
    <hr />
      <table 
         data-cy="dock-table-remove"
         id="dock-table-remove"
         style={{width: '100%'}}>
        <thead>
          <tr>
            <th style={{ textAlign: 'left' }}>Planta</th>
            <th style={{ textAlign: 'left' }}>Turno</th>
            <th style={{ textAlign: 'left' }}>Início</th>
            <th style={{ textAlign: 'left' }}>Fim</th>
            <th style={{ textAlign: 'left' }}>Cotas atuais</th>
          </tr>
        </thead>
        <tbody>
          {results?.data?.quotas?.affectedPlantQuotas.map((d, index) => (
          <tr key={index}>
            <td style={{ textAlign: 'left' }}>{capitalize(d.plant_name)}</td>
            <td style={{ textAlign: 'left' }}>{capitalize(d.time_block_name)}</td>
            <td style={{textAlign: 'left'}}>{prettyDate(d.starts_date)}</td>
            <td style={{textAlign: 'left'}}>{(!d.ends_date) ? `Em diante`: prettyDate(d.ends_date)}</td>
            <td style={{ textAlign: 'left' }}>{d.quantity}</td>
          </tr>
          ))}
        </tbody>
      </table>
    <hr/>
    <strong style={{fontSize: '1.3em', textAlign: 'center', width: '100%', display: 'block'}}>
      {`Cota Cliente`}
    </strong>
    <hr />
      <table 
         data-cy="dock-table-remove-2"
         id="dock-table-remove-2"
         style={{width: '100%'}}>
        <thead>
          <tr>
            <th style={{ textAlign: 'left' }}>Planta</th>
            <th style={{ textAlign: 'left' }}>Data</th>
            <th style={{ textAlign: 'left' }}>Controle</th>
            <th style={{ textAlign: 'left' }}>Cotas</th>
          </tr>
        </thead>
        <tbody>
          {results?.data?.quotas?.affectedClientQuotas.map((d, index) => (
            <tr key={index}>
              <td style={{ textAlign: 'left' }}>{capitalize(d.plant_name)}</td>
              <td style={{textAlign: 'left'}}>{prettyDate(d.date)}</td>
              <td style={{ textAlign: 'left' }}>{capitalize(d.id_time_block ? `Por turno` : `Por dia`)}</td>
              <td style={{ textAlign: 'left' }}>{d.quantity}</td>
            </tr>
          ))}
        </tbody>
      </table>
    <hr />
  </>
);

const activeSchedulingsStructure = (results) => {
  if (results?.data?.schedulings.affectedSchedulings.length > 0) {

    return (
      <>
        {schedulingReport(results)}
      </>
    )

  } else {

    return (
      <>
        {quotaReport(results)}
      </>
    )
  }

}

const ModalRemoveDock = ({data, ...props}) => {
  const {isOpen, closeReadingNotificationDialog} = props
  const table = renderToString(activeSchedulingsStructure(data))

  return (
    <DialogMessage
      isOpen={!!data?.showDialog && isOpen}
      data-cy="dock-remove-feedback"
      id="dock-remove-feedback"
      closeReadingNotificationDialog={closeReadingNotificationDialog}
      message={table}
      maxWidth="lg"
    />
  )
}

export default ModalRemoveDock;
